import { withClientToken } from '../../actions/helpers/tokenHelpers';
import { forgotPassword } from '../../actions/sagAuth';
import { ACTIONS as layoutActions } from '../layout';

const INIT = 'changePassword/INIT';
const SET_EMAIL = 'changePassword/SET_EMAIL';
const SET_ATTEMPTING_LOGIN = 'changePassword/SET_ATTEMPTING_LOGIN';
const SUBMIT_FORGOT_PASS = 'changePassword/SUBMIT_FORGOT_PASS';

const defaultState = {
  email: '',
  attemptingLogin: false,
  forgotPassSubmitted: false,
  errorMessage: '',
};

const setAttemptingLogin = bool => ({ type: SET_ATTEMPTING_LOGIN, bool });

const submitForgotPass = (bool, errorMessage) => ({
  type: SUBMIT_FORGOT_PASS,
  bool,
  errorMessage,
});

const handleForgotPassword = () => async (dispatch, getState) => {
  const { email } = getState().routes.changePassword;

  if (!email) {
    return dispatch(layoutActions.setAlert('Please enter email', 'danger'));
  }

  dispatch(setAttemptingLogin(true));

  try {
    const { error, errorCode } = await withClientToken({
      action: forgotPassword,
      args: [email],
    });

    if (error) {
      dispatch(
        layoutActions.setAlert(
          `Some error Occured: ${error && error.errorMessage}`,
          'danger',
        ),
      );
    }

    dispatch(submitForgotPass(true, error && error.errorMessage));
    dispatch(setAttemptingLogin(false));
  } catch (err) {
    console.error(err);
    dispatch(setAttemptingLogin(false));
    dispatch(
      layoutActions.setAlert(
        'Some error eccured. Please try after some time',
        'danger',
      ),
    );
  }
};

export const ACTIONS = {
  init: () => ({ type: INIT }),
  changeEmail: val => ({ type: SET_EMAIL, val }),
  handleForgotPassword,
  submitForgotPass,
};

function changePassword(state = defaultState, action) {
  switch (action.type) {
    case INIT:
      return Object.assign({}, state);
    case SET_EMAIL:
      return Object.assign({}, state, {
        email: action.val,
      });
    case SET_ATTEMPTING_LOGIN:
      return Object.assign({}, state, {
        attemptingLogin: action.bool,
      });
    case SUBMIT_FORGOT_PASS:
      return Object.assign({}, state, {
        forgotPassSubmitted: action.bool,
        errorMessage: action.errorMessage,
      });
    default:
      return Object.assign({}, state);
  }
}

export default changePassword;



// WEBPACK FOOTER //
// ./src/reducers/routeReducers/changePassword.js